import { handleActions } from 'redux-actions';
import { types } from '../constants';

const INITIAL_STATE = {
  eventsByBranch: {
    items: [],
    itemsCopy: [],
    isLoading: false,
    errorMessage: '',
    searchTerm: ''
  },
  eventsByCompany: {
    items: [],
    isLoading: false,
    errorMessage: ''
  },
  deleteEvent: {
    openDialog: false,
    event: null,
    isSaving: false,
    errorMessage: false
  }
};

const startDeleteEvent = (state) => {
  return {
    ...state,
    deleteEvent: {
      ...state.deleteEvent,
      isSaving: true
    }
  };
};
const deleteEventSuccess = (state, { eventId }) => {
  var eventsByBranch = state.eventsByBranch.items;
  var filteredEvents = eventsByBranch.filter((event) => event.id !== eventId);

  return {
    ...state,
    deleteEvent: {
      ...state.deleteEvent
    },
    eventsByBranch: {
      ...state.eventsByBranch,
      items: filteredEvents
    }
  };
};
const deleteEventFailure = (state, { errorMessage }) => {
  return {
    ...state,
    deleteEvent: {
      ...state.deleteEvent,
      errorMessage
    }
  };
};
const deleteEventFinished = (state) => {
  return {
    ...state,
    deleteEvent: {
      ...state.deleteEvent,
      isSaving: false
    }
  };
};

const startFetchAllEventsForBranch = (state) => {
  return {
    ...state,
    eventsByBranch: {
      ...state.eventsByBranch,
      isLoading: true
    }
  };
};

const fetchAllEventsForBranchSuccess = (state, { events }) => {
  return {
    ...state,
    eventsByBranch: {
      ...state.eventsByBranch,
      items: events,
      itemsCopy: events
    }
  };
};

const fetchAllEventsForBranchFailure = (state, { errorMessage }) => {
  return {
    ...state,
    eventsByBranch: {
      ...state.eventsByBranch,
      errorMessage
    }
  };
};

const fetchAllEventsForBranchFinished = (state) => {
  return {
    ...state,
    eventsByBranch: {
      ...state.eventsByBranch,
      isLoading: false
    }
  };
};

const changeSearchTermAllEvents = (state, { searchTerm }) => {
  let events = [...state.eventsByBranch.itemsCopy];

  let filteredEvents = events.filter(
    (e) => e.description && e.description.toLowerCase().includes(searchTerm)
  );

  return {
    ...state,
    eventsByBranch: {
      ...state.eventsByBranch,
      searchTerm,
      items: filteredEvents
    }
  };
};

const submitEventSuccess = (state, { submittedEvent }) => {
  let events = [...state.eventsByBranch.items];
  let updatedEventIndex = events.findIndex((a) => a.id === submittedEvent.id);

  //Means updated
  if (updatedEventIndex !== -1) {
    events[updatedEventIndex] = submittedEvent;
  } else {
    events = [...events, submittedEvent];
  }

  return {
    ...state,
    eventsByBranch: {
      ...state.eventssByBranch,
      items: events,
      itemsCopy: events
    }
  };
};

const openDeleteEventDialog = (state, { open, event }) => {
  return {
    ...state,
    deleteEvent: {
      ...state.deleteEvent,
      openDialog: open,
      event: open === true ? event : null
    }
  };
};

const startFetchAllEventsForCompany = (state) => {
  return {
    ...state,
    eventsByCompany: {
      ...state.eventsByCompany,
      isLoading: true
    }
  };
};

const fetchAllEventsForCompanySuccess = (state, { events }) => {
  return {
    ...state,
    eventsByCompany: {
      ...state.eventsByCompany,
      items: events,
      itemsCopy: events
    }
  };
};

const fetchAllEventsForCompanyFailure = (state, { errorMessage }) => {
  return {
    ...state,
    eventsByCompany: {
      ...state.eventsByCompany,
      errorMessage
    }
  };
};

const fetchAllEventsForCompanyFinished = (state) => {
  return {
    ...state,
    eventsByCompany: {
      ...state.eventsByCompany,
      isLoading: false
    }
  };
};

//Handles the incoming actions.
export default handleActions(
  {
    [types.START_FETCH_ALL_EVENTS_FOR_BRANCH]: startFetchAllEventsForBranch,
    [types.FETCH_ALL_EVENTS_FOR_BRANCH_SUCCESS]: fetchAllEventsForBranchSuccess,
    [types.FETCH_ALL_EVENTS_FOR_BRANCH_FAILURE]: fetchAllEventsForBranchFailure,
    [types.FETCH_ALL_EVENTS_FOR_BRANCH_FINISHED]: fetchAllEventsForBranchFinished,

    [types.START_FETCH_ALL_EVENTS_FOR_COMPANY]: startFetchAllEventsForCompany,
    [types.FETCH_ALL_EVENTS_FOR_COMPANY_SUCCESS]: fetchAllEventsForCompanySuccess,
    [types.FETCH_ALL_EVENTS_FOR_COMPANY_FAILURE]: fetchAllEventsForCompanyFailure,
    [types.FETCH_ALL_EVENTS_FOR_COMPANY_FINISHED]: fetchAllEventsForCompanyFinished,

    [types.CHANGE_SEARCH_TERM_ALL_EVENTS]: changeSearchTermAllEvents,

    [types.SUBMIT_EVENT_SUCCESS]: submitEventSuccess,

    [types.OPEN_DELETE_EVENT_DIALOG]: openDeleteEventDialog,

    [types.START_DELETE_EVENT]: startDeleteEvent,
    [types.DELETE_EVENT_SUCCESS]: deleteEventSuccess,
    [types.DELETE_EVENT_FAILURE]: deleteEventFailure,
    [types.DELETE_EVENT_FINISHED]: deleteEventFinished
  },
  INITIAL_STATE
);
